export default __webpack_public_path__ + "static/media/img-0486-andorra-full-face.fa36fa74.png";